import { render, staticRenderFns } from "./Advert4.vue?vue&type=template&id=660e8174&scoped=true&"
import script from "./Advert4.vue?vue&type=script&lang=ts&"
export * from "./Advert4.vue?vue&type=script&lang=ts&"
import style0 from "./Advert4.vue?vue&type=style&index=0&id=660e8174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660e8174",
  null
  
)

component.options.__file = "Advert4.vue"
export default component.exports